const API_BASE_URL = (typeof window !== 'undefined' && (window as any).ENV?.EXPO_PUBLIC_ACCOUNT_API_URL) || '';

export async function fetchAccount(userId: string, token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/account/${userId}`, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch account for user ${userId}`);
  }
  const result = await response.json();
  return result.data;
}

export async function updateOverdraft(userId: string, overdraftLimit: number, token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/account/${userId}/overdraft`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ overdraft_limit: overdraftLimit })
  });
  if (!response.ok) {
    throw new Error(`Failed to update overdraft limit for user ${userId}`);
  }
  return response.json();
}

export async function createAccount(
  userId: string,
  overdraftLimit: number,
  initialBalance: number,
  token: string
): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/account`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: userId,
      overdraft_limit: overdraftLimit,
      initial_balance: initialBalance
    })
  });
  if (!response.ok) {
    throw new Error(`Failed to create account for user ${userId}`);
  }
  return response.json();
}

export async function seedAccountsDatabase(token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/account/seed`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error("Failed to seed accounts database");
  }

  return response.json();
}

export async function deleteAccount(userId: string, token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/account/${userId}`, {
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to delete account for user ${userId}`);
  }

  return response.json();
}

export async function fetchAccountMovements(
  userId: string,
  token: string,
  limit?: number,
  offset?: number
): Promise<any> {
  let url = `${API_BASE_URL}/account/${userId}/movements`;
  const params = new URLSearchParams();
  if (limit !== undefined) params.append("limit", String(limit));
  if (offset !== undefined) params.append("offset", String(offset));

  const queryStr = params.toString();
  if (queryStr) {
    url += "?" + queryStr;
  }

  const response = await fetch(url, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch movements for user ${userId}`);
  }

  const result = await response.json();
  return result.data;
}

export async function registerFinancialMovement(
  userId: string,
  movementData: { amount: number; type: "CREDIT" | "DEBIT"; concept: string; reference_id?: string },
  token: string
): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/account/${userId}/movement`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(movementData)
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Failed to register movement for user ${userId}`);
  }

  return response.json();
}
